export function setSessionStorage(key, value) {
  if (!sessionStorage) {
    console.warn("Session storage is not supported in this environment.");
    return;
  }
  sessionStorage.setItem(key, JSON.stringify(value));
}

export function getSessionStorage(key) {
  if (!sessionStorage) {
    console.warn("Session storage is not supported in this environment.");
    return;
  }
  const item = sessionStorage.getItem(key);

  if (!item) {
    return null;
  }

  try {
    return JSON.parse(item);
  } catch (e) {
    return item;
  }
}

export function removeSessionStorage(key) {
  if (!sessionStorage) {
    console.warn("Session storage is not supported in this environment.");
    return;
  }
  // remove
  sessionStorage.removeItem(key);
}
